const env = process.env.REACT_APP_NODE_ENV;

export const DEFAULT_EMPTY = "-";

export const ENV = Object.freeze({
    DEV: env === "development",
    STG: env === "staging",
    PRD: env === "production",
    TEST: env === "test",
});

export const CONTENT_VERSION = process.env.REACT_APP_VERSION || "1.0.0";
